import { useEffect, useState } from "react";
import { continueTransition, getTransitionStatus, submitFeeStructure, submitPromotion } from "../services/yearTransitionService";
import { TransitionPromotionInput, TransitionResponse } from "../types";

export const useYearTransition = () => {
  const [response, setResponse] = useState<TransitionResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [acting, setActing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getTransitionStatus().then((r) => {
      setResponse(r);
      setLoading(false);
    });
  }, []);

  const runAction = async (action: () => Promise<TransitionResponse>) => {
    setActing(true);
    setError(null);
    try {
      const r = await action();
      setResponse(r);
      if (!r.success) setError(r.message);
    } catch (e) {
      setError("Something went wrong. Please try again.");
    } finally {
      setActing(false);
    }
  };

  return {
    response,
    loading,
    acting,
    error,
    actions: {
      promote: (grade: string, section: string, promotions: TransitionPromotionInput[]) => runAction(() => submitPromotion(grade, section, promotions)),
      continueStage: () => runAction(() => continueTransition()),
      submitFees: (feeStructure: { name: string; newFee: number }[]) => runAction(() => submitFeeStructure(feeStructure)),
    },
  };
};
